import { Controller } from "@ui/components/Form";

import { useConfig } from "@jti/app-context/useConfig";
import { SelectionTileItem } from "@jti/core-components";
import type { RegionSelectorOption } from "@jti/fe-common";

import styles from "./RegionSelector.module.scss";

export type RegionSelectorProps = {
  title?: string;
};

export const RegionSelector = ({ title }: RegionSelectorProps) => {
  const { regionSelector } = useConfig();
  const isRegionSelectorEnabled = regionSelector.isRegionSelectorEnabled;
  const configOptions: RegionSelectorOption[] = regionSelector.regionOptions;

  if (!isRegionSelectorEnabled || !configOptions.length) {
    return null;
  }

  const defaultRegionId =
    configOptions.find((option: RegionSelectorOption) => option.isDefault)?.id ?? configOptions[0].id;

  return (
    <div className={styles.wrapper}>
      {title && <p className={styles.title}>{title}</p>}
      <div className={styles.options}>
        <Controller
          name="regionId"
          defaultValue={defaultRegionId}
          render={({ field }) => (
            <>
              {configOptions.map((option: RegionSelectorOption) => (
                <SelectionTileItem
                  key={option.id}
                  value={option.id}
                  label={option.regionName}
                  name="region-selector"
                  checked={option.id === field.value}
                  onChange={field.onChange}
                />
              ))}
            </>
          )}
        />
      </div>
    </div>
  );
};
